
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/board/landing",
      function () {
        return require("private-next-pages/board/landing/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/board/landing"])
      });
    }
  